<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>

</template>
<script>
import ck from '../../js/cookieset';

export default {
  name: 'home',
  data: () => ({
  }),
  methods: {
  },
  beforeCreate() {
    const islogin = this.$store.state.islogin;
    const logstatus = ck.getCookie("login-status");
    console.log(this.$route.path)
    if (!logstatus && !islogin) {
      this.$router.push({ path: "/login", query: { next:"/" } });
    }
  },
};
</script>
